__turbopack_context__.v({
  "Actions": "index-module__DVI5NG__Actions",
  "Backdrop": "index-module__DVI5NG__Backdrop",
  "Button": "index-module__DVI5NG__Button",
  "Center": "index-module__DVI5NG__Center",
  "Content": "index-module__DVI5NG__Content",
  "Description": "index-module__DVI5NG__Description",
  "Hint": "index-module__DVI5NG__Hint",
  "Instructions": "index-module__DVI5NG__Instructions",
  "Popup": "index-module__DVI5NG__Popup",
  "Root": "index-module__DVI5NG__Root",
  "SwipeArea": "index-module__DVI5NG__SwipeArea",
  "SwipeLabel": "index-module__DVI5NG__SwipeLabel",
  "Title": "index-module__DVI5NG__Title",
  "Viewport": "index-module__DVI5NG__Viewport",
});
